import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/css/style.css'  //全局样式

// 插件使用
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import Mint from 'mint-ui'
Vue.use(Mint)

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// 注册全局组件
import zmlpagebanner from '@/components/page_banner.vue'
Vue.component('zmlpagebanner',zmlpagebanner);

import zmlmenupage from '@/components/myMenu_page.vue'
Vue.component('zmlmenupage',zmlmenupage);

import gototop from '@/components/goToTop.vue'
Vue.component('gototop',gototop)

// 使用vuex
 import Vuex from 'vuex';
 Vue.use(Vuex);
 const store = new Vuex.Store({
   state: {
     isClose1:false,
     isClose2:false,
   },
   mutations: {
     myIsClose1(state,isclose1){
		state.isClose1 = isclose1
	 },
	 myIsClose2(state,isclose2){
		state.isClose2 = isclose2
	 },
   }
 })

// 跳转后返回顶部
router.afterEach((to,from,next) => {
	window.scrollTo(0,0);
})
router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
})

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js